/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import React, { PureComponent } from 'react';
import {
    object, shape, bool, string, number,
} from 'prop-types';

import HTML5 from './HTML5Video';
import Header from './Partials/Header';
// Render Video content on the page
// Accepts content hosted by YouTube and alt-hosted HTML5 video.

export class Video extends PureComponent {
    render() {
        const { data  } = this.props;
        if (data) {
            const width = data.width ? data.width : '100%';
            const height = data.height ? data.height : '100%';
            const autoPlay = data.autoplay ? 'autoplay' : '';
            const heading = () => {
                if (data.heading) return <Header data={data} />;
                return null;
            };
            if (data.source === 'YouTube') {
                const params = data.youtube_parameters;
                const src = `https://www.youtube.com/embed/${params?.youtube_id}`;
                const allowFullScreen = params?.allow_fullscreen ? 'allowFullScreen' : '';
                return (
                    <div
                        style={{
                            position: 'relative',
                            width: '100%',
                            maxWidth: `${width}px`,
                            overflow: 'hidden',
                            margin: '40px auto',
                            maxHeight: `${height}px`,
                        }}
                    >
                        {heading()}
                        <div style={{
                            position: 'relative',
                            paddingBottom: '56.25%',
                            paddingTop: '30px',
                            height: '0',
                            overflow: 'hidden',
                            maxWidth: `${width}px`,
                        }}
                        >
                            <iframe
                                title="video"
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '0',
                                    width: '100%',
                                    maxWidth: `${width}px`,
                                    height: '100%',
                                    maxHeight: `${height}px`,
                                }}
                                src={src}
                                frameBorder="0"
                                allow={`accelerometer; ${autoPlay}; encrypted-media; gyroscope; picture-in-picture`}
                                {...allowFullScreen}
                            />
                        </div>
                    </div>
                );
            }
            if (data.source === 'Other') {
                return (

                    <div style={{
                        position: 'relative',
                        paddingTop: '30px',
                        overflow: 'hidden',
                        margin: '40px auto',
                        maxWidth: `${width}px`,
                        maxHeight: `${height}px`,
                    }}
                    >
                        {heading()}
                        <HTML5 data={data} />
                    </div>
                );
            }
        }
        return <></>;
    }
}

Video.propTypes = {
    data: shape({
        alt_source_url: string,
        autoplay: bool,
        heading: bool,
        height: number,
        optional_image: shape({
            title: string,
            url: string,
        }),
        play_location: string,
        source: string,
        title: string,
        width: number,
        youtube_parameters: shape({
            allow_fullscreen: bool,
            hide_related_videos: bool,
            show_controls: bool,
            youtube_id: string,
        }),
    }).isRequired,
    classes: object.isRequired,
};

export default Video;
